import axios from "axios";

export default {
  namespaced: true,
  state: {
    webprojects: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    webprojectsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_WEBPROJECTS(state, payload) {
      state.webprojects = payload;
      state.isReceiving = false;
    },
    RECEIVING_WEBPROJECTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_WEBPROJECT(state, payload) {
      state = Object.assign(state, {
        webprojects: [...state.webprojects, payload],
        isReceiving: false,
      })
    },
    RECEIVING_WEBPROJECT(state) {
      state.isReceiving = true;
    },
    UPDATED_WEBPROJECT(state, payload) {
      let index = state.webprojects.findIndex(webproject => webproject._id === payload._id);
      state = Object.assign(state, {
        webprojects: state.webprojects.map((webproject, i) => {
          if (i === index) {
            return Object.assign({}, webproject, payload);
          }
          return webproject;
        }),
        isUpdating: false,
        webprojectsMessage: 'WebProjects has been updating!',
      })
    },
    UPDATING_WEBPROJECT(state) {
      state.isUpdating = true;
    },
    DELETED_WEBPROJECT(state, payload) {
      let indexToDelete = state.webprojects.findIndex(webproject => webproject._id === payload._id);
      let webprojects = [...state.webprojects];
      webprojects.splice(indexToDelete, 1);
      state = Object.assign(state, {
        webprojects: [...webprojects],
        isDeleting: false,
        idToDelete: null,
        webprojectsMessage: 'WebProject has been Deleted!',
      });
    },
    DELETING_WEBPROJECT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {

    deleteWebProjectRequest({dispatch}, payload) {
      dispatch("deletingWebProject", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/webproject/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        console.log(response.data);
        dispatch("deleteWebProject", {_id: payload._id});
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteWebPageRequest({dispatch}, payload) {
      try{
        dispatch("deletingWebProject", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/webpage/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteWebContainerRequest({dispatch}, payload) {
      try{
        dispatch("deletingWebProject", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/webcontainer/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteWebItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingWebProject", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/webitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getWebProjectsRequest({dispatch}) {
      dispatch("receivingWebProjects");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/webprojects';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveWebProjects", res.data);
      })
    },
    async insertWebProjectRequest({dispatch}, payload) {
      dispatch("receivingWebProject");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/webproject';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveWebProject", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertWebPageRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/webpage/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertWebContainerRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingWebProject");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/webcontainer/' + payload.pageid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertWebItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        console.log('2', payload)
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/webitem/' + payload.containerid;
        console.log('3', url)
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertWebItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/webitem/withimage/' + payload.containerid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        console.log(payload)
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateWebProjectRequest({dispatch}, payload) {
      dispatch("updatingWebProject");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/webproject/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateWebProject", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateWebPageRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/webpage/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateWebContainerRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/webcontainer/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateWebItemRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/webitem/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateWebItemWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingWebProject");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/webitem/withimage/' + id;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveWebProjects({commit}, payload) {
      commit("RECEIVED_WEBPROJECTS", payload)
    },
    receivingWebProjects({commit}) {
      commit("RECEIVING_WEBPROJECTS")
    },
    receiveWebProject({commit}, payload) {
      commit("RECEIVED_WEBPROJECT", payload)
    },
    receivingWebProject({commit}) {
      commit("RECEIVING_WEBPROJECT")
    },
    updateWebProject({commit}, payload) {
      commit("UPDATED_WEBPROJECT", payload)
    },
    updatingWebProject({commit}) {
      commit("UPDATING_WEBPROJECT")
    },
    deleteWebProject({commit}, payload) {
      commit("DELETED_WEBPROJECT", payload)
    },
    deletingWebProject({commit}, payload) {
      commit("DELETING_WEBPROJECT", payload)
    }
  },
};
